export type Vehicle = {
    id: string;
    searchName: string;
    plate?: string;
    fleetGroupIds?: string[];
    fleetGroupName?: string;
    hasOrderCommunicationLicense?: boolean;
    hasPocketDriverDataSource?: boolean;
};

export const getVehicleDisplayName = (vehicle: Pick<Vehicle, 'plate' | 'searchName'>) =>
    vehicle.plate?.trim() || vehicle.searchName;
